import {SWITCH_LEFT_NAV} from "../actionType/index";

let obj = {
    activeLeftNav: 'en',
};

export default (state = obj, action) => {
    if (action.type === SWITCH_LEFT_NAV) {
        let nowData = JSON.parse(JSON.stringify(state));
        nowData.activeLeftNav = action.activeLeftNav;
        return nowData;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/leftNavReducer.js